import * as React from 'react';
import styled from 'styled-components';

interface IInterview {
  children: string;
}

const InterviewIngressStyle = styled.div`
  text-align: center;
  .ingress {
    font-size: 1.2em;
    @media all and (min-width: 600px) and (max-width: 899px) {
      font-size: 1.2em;
    }
    @media all and (min-width: 900px) {
      font-size: 1.5em;
    }
  }
`;

const InterviewIngress: React.FC<IInterview> = ({ children }) => {
  return (
    <InterviewIngressStyle dangerouslySetInnerHTML={{ __html: children }} />
  );
};

export default InterviewIngress;
